export default __webpack_public_path__ + "static/media/2c.9895dd61.jpg";